import { ref } from 'vue';
import { usePage } from '@inertiajs/vue3';

export default function useTheme() {
  const skin = ref(usePage().props.skin ?? 'default');
  const structure = ref(usePage().props.structure ?? 'default');

  const adaptTheme = (newSkin = null, newStructure = null) => {
    skin.value = newSkin ?? skin.value ?? 'default';
    let skinCss = document.getElementById('forgeron-skin-css');
    skinCss.setAttribute('href', `/css/skins/${skin.value}/app.css`);

    structure.value = newStructure ?? structure.value ?? 'default';
    let structureCss = document.getElementById('forgeron-structure-css');
    structureCss.setAttribute('href', `/css/structures/${structure.value}/app.css`);
  };

  return {
    adaptTheme,
  };
}
